import HttpClient from "../infra/HttpClient";

export default class ServicesService {

    constructor (readonly httpClient: HttpClient, readonly baseUrl: string) {
    }

    async getSession () {
        return this.httpClient.get(`${this.baseUrl}/auth/session`);
    }

	async changeCustomer (idCustomer) {
		return this.httpClient.post(`${this.baseUrl}/auth/changeCustomer`, { idCustomer });
	}
}
